<form [formGroup]="formGroup">
  <quill-editor formControlName="editorContent"
    [placeholder]="'news.text' | translate"
    [modules]="modules()"
    (onEditorCreated)="getEditorInstance($event)"></quill-editor>
</form>